<template>
    <div @click="(event) => isOutside(event)">
       <modal class="modal-wrapper" :width="width" :height="height"  @hide-modal="next">
        <template v-slot:content>
            <div class="modal-inner px-2 w-full">
                <div class="pb-1/2">
                    <div class="text-2xl font-bold pb-1/2">
                        {{ title }}
                    </div>
                    <hr />
                </div>
                <UserForm 
                    ref="billing"
                    formModule="billing"
                    :formModel="{...billing}"
                    :formSchema="editBillingFormSchema"
                    :formPlaceholders="checkoutContent.formPlaceholders"
                    :formHints="checkoutContent.formHints"
                    :formValidationErrorMessages="checkoutContent.validationErrorMessages"
                    :formSelectFieldOptions="{}" />
                <div class="banner" v-if="showBanner">
                    <div class="banner">
                        <span class="font-bold">Incomplete Field(s): </span>
                        <span>Please make sure to fill out all of the information above. </span>
                    </div>
                </div>
                <ButtonSection
                    :inputValid="true"
                    :buttonText="buttonText"
                    :buttonStyling="'justify-center'"
                    @progress="submitHandler"
                />
            </div>
        </template>
       </modal>
    </div>
            
</template>

<script>
import { mapGetters } from 'vuex';
import editBillingFields from '../../../forms/schemas/editBillingFields'
import UserForm from '../../../components/utils/user-form/user-form'
import Modal from '../../utils/modal';
import { WebstoreResources } from "../../../mixins/webstore-resources";
import informational from "../webstore/Information"
import ButtonSection from "../webstore/ButtonSection.vue";
import { analyticsTrack } from "../../../plugins/segment";
import {countriesWithoutStates} from "../../../forms/field-templates/address/settings";
export default {
    components: {Modal, informational, UserForm, ButtonSection},
    mixins: [WebstoreResources],
    props: {
        title: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            required: true
        },
    },
    data() {
      return {
        form: {},
        currentStep: 0, 
        fieldsToMonitor: [],
        showBanner: false,
        requiredFields: new Set(['firstName', 'lastName', 'email', 'phone', 'address1', 'city', 'zip', 'state', 'country']),
        dirty: false
      }
    },
    computed: {
        ...mapGetters(['applicationVersion', 'typeOfRenewal', 'productSource']),
        ...mapGetters('billing', [
            'billing'
        ]),
        ...mapGetters('content', [
                'checkoutContent'
            ]),
            ...mapGetters('checkout', [
                'accountId',
                'opptyId'
            ]),
        width() {
            return window.innerWidth > 550 ? '700px' : '90%';
        },
        height() {
            return window.innerWidth > 550 ? '800px' : '90%';
        },
        editBillingFormSchema(){
            return editBillingFields;
        }
    },
    methods: {
        next(){
            if(!this.dirty){
                analyticsTrack("Edit Billing Info Modal Closed", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
                this.$emit('hide-modal');
            }
        },
        isOutside(event) {
            if(!this.dirty && !event.target.closest('.modal-inner')){
                analyticsTrack("Edit Billing Info Modal Closed", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
                this.$emit('hide-modal');
            }
        },

        submitHandler(){
            if (!this.showBanner) {
                analyticsTrack("Edit Billing Info Submit Button Clicked", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
                this.$emit('hide-modal');
            }
            
        }
    },
    created () {
        analyticsTrack("Edit Billing Info Button Clicked", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
        if (countriesWithoutStates.includes(this.billing.country.toLowerCase())) {
            this.requiredFields.delete('state');
        }
    },
    watch: {
        billing: {
            deep: true,
            handler(){
                this.dirty = true;
                for(const field in this.billing) {
                    if (this.requiredFields.has(field) && this.billing[field] === "") {
                        this.showBanner = true;
                        return;
                    }
                }
                this.showBanner = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .banner{
        height: auto;

        font-family: 'Roboto';
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        /* identical to box height, or 129% */

        color: #B11121;
        padding: 10px;
        background: #FCE9EC;
    }

    :deep(.col){
        padding-left: 0px;
    }
    :deep(.form){
        height: auto
    }
    :deep(.vue-form-generator) {

        label {
            font-weight: bolder;
            font-size: 15px;
            margin: 0.5em auto;
            color: #00263E;
        }

        .error {
            background-color: white;
            text-align: left;
            margin: 0px;
            padding: 0px;
        }

        .errors {
            position: relative;
            text-align: left;

            span {
                background-image: none;
                padding-left: 0px;
            }
        }

        .form-control {
            width: 100%;
            height: 44px;
            font-size: 18px;
            color:#302f32;
            margin-bottom: 10px;
            line-height: 2.0rem;
            text-align: left;
            background: #FFFFFF;
            border: 1px solid #0384FB; 
            box-sizing: border-box;
            box-shadow: none;
            transition: none;
            border-radius: 4px;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            outline: none;
            
        }

        .additional-email {
            display: flex;
            flex-direction: row-reverse;
            justify-content: flex-end;
            height: 30px;
            margin-top: -20px;
            display: none;
        }

        .additional-email .field-wrap {
            height: 15px;
            margin-top: 3px;
            margin-right: 5px;
        }

        .additional-email .form-control {
            margin: 0;
            height: 100% !important;
            width: 100% !important;
            margin-right: 3px;
            min-width: 15px;
        }

        .additional-email label {
            margin: 0;
            font-weight: 300 !important;
        }

        #additional-email {
            margin-top: 1px;
            margin-left: 0px;
        }

        @media only screen and (max-width: 736px) {
            .additional-email {
                margin-top: 10px;
                margin-bottom: 30px;
            }
        }

        .shipping-method {
            label {
                font-size: 24px;
                font-weight: normal;
                margin-bottom: 24px;
            }

            .radio-list {
                label {
                    font-weight: bold;
                    font-size: 18px;
                    margin-bottom: 24px;
                }
            }
        }

        /* only display on tablet and above */
        @media only screen and (min-width: 736px) {

            .col.xs-12 {
                max-width: 100%; /* Safari display fix */
                padding-left: 0px;
            }

            .col.md-6 {
                max-width: 100%;
                flex-basis: 100%;
                padding-left: 0px; /* Safari display fix */
            }

            .col.md-3 {
                max-width: 100%;
                flex-basis: 100%;
                padding-left: 0px; /* Safari display fix */
            }
        }
    }

</style>